const getWalletVerifiedCredential = (walletAddress, verifiedCredentials) => verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.find((credential) => credential.address === walletAddress);

export { getWalletVerifiedCredential };
